import { cn } from "@reactive-resume/utils";
import type { HTMLAttributes } from "react";

export const BuilderScroll = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      "overflow-y-auto overflow-x-hidden overscroll-contain",
      "[scrollbar-color:rgb(99_102_241)_transparent] [scrollbar-width:thin]",
      "[&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar]:w-1.5",
      "[&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-indigo-400",
      className,
    )}
    {...props}
  />
);
